import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonGlobalService {
  private ip;
  private linename;

  constructor() {
    this.ip = sessionStorage.getItem('current-device-ip');
    this.linename = sessionStorage.getItem('current-line-name');
  }

  set ipAddress(ip) {
    sessionStorage.setItem('current-device-ip',ip);
    this.ip = ip;
  }
  get ipAddress() {
    return this.ip;
  }

  set lineName(name) {
    sessionStorage.setItem('current-line-name', name);
    this.linename = name;
  }
  get lineName() {
    return this.linename;
  }

  getStringAtIndex(inputString: string, index: number): string {
    // Split the input string by semicolon
    const parts: string[] = inputString.split(';');

    // Check if the index is within the bounds of the array
    if (index >= 0 && index < parts.length) {
      return parts[index];
    } else {

      return "";
    }
  }

}
